import { Alert, AlertTitle, Box, Button, Card, CardContent, CardHeader, Chip, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ScreenGreeting } from '../../../../../../Components/Molecules';
import { formatCurrency } from '../../../../../../Utils/formatters';

const Info = ({ title, text }) => {
  return (
    <Box display='flex' flexDirection='column'>
      <Typography variant='subtitle1'>{title}</Typography>
      <Typography >{text}</Typography>
    </Box>
  )
}

const PaymentDetails = () => {

  const [payment, setPayment] = useState({
    operators: [
      { id: '1', name: 'Kevin', status: { name: 'Aprovado', code: 'approve' }, updatedAt: '2025-07-06 11:30' },
      { id: '2', name: 'Kaue', status: { name: 'Pendente', code: 'pending' }, updatedAt: null },
      { id: '3', name: 'Vitor', status: { name: 'Negado', code: 'decline' }, updatedAt: '2025-07-06 09:30' },
    ],
    status: 'Esperando Aprovação',
    product: 'p2p',
    amount: 120000,
    dueDate: '2025-07-07',
    sendDate: '2025-07-06',
    id: '',
    favored: 'Kaue',
    operator: 'Kevin'
  });

  const isPendingApprove = true;

  const getChipColor = (code = '') => {
    if (code === 'approve') return 'success';
    if (code === 'pending') return 'info';

    return 'error';
  }

  const acceptedPayment = (isAccepted = false) => {

  }

  return (
    <Box>
      <ScreenGreeting
        title="Detalhes do Pagamento"
        subTitle="Verifique os detalhes do pagamento agendado e os operadores que aprovaram a operação"
      />

      <Box>
        <Button component={Link} to="/pay-office" variant='contained'>Voltar</Button>
      </Box>

      {
        isPendingApprove && (
          <Alert sx={{ mt: 2 }} variant="standard" severity="info">
            <AlertTitle>Aprovação necessária</AlertTitle>
            Para continuar, você precisa aprovar o pagamento.
            <Box sx={{ mt: 3, gap: 2, display: 'flex', ml: -1 }}>
              <Button variant='text' onClick={() => acceptedPayment(true)} color='success'>Aprovar</Button>
              <Button variant='text' onClick={() => acceptedPayment(false)} color='error'>Rejeitar</Button>
            </Box>
          </Alert>
        )
      }

      <Card sx={{ mt: 2 }}>
        <CardHeader title="Informações" />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <Info title='Operador' text={payment.operator} />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={2}>
              <Info title='Favorecido' text={payment.favored} />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <Info title='Produto' text={payment.product} />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <Info title='Valor' text={formatCurrency(payment.amount)} />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <Info title='Data de Envio' text={format(parseISO(payment.sendDate), 'dd/MM/yyyy HH:mm')} />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <Info title='Data de Vencimento' text={format(parseISO(payment.dueDate), 'dd/MM/yyyy')} />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <Info title='Status' text={payment.status} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {
        payment.operators.length > 0 && (
          <Card sx={{ mt: 2 }}>
            <CardHeader title="Aprovações" />
            <CardContent sx={{ p: 0 }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Operador</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Atualizado em</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      payment.operators.map(operator => (
                        <TableRow key={operator.id}>
                          <TableCell>{operator.name}</TableCell>
                          <TableCell>
                            <Chip label={operator.status.name} color={getChipColor(operator.status.code)} />
                          </TableCell>
                          <TableCell>
                            {operator.updatedAt && format(parseISO(operator.updatedAt), 'dd/MM/yyyy HH:mm')}
                          </TableCell>
                        </TableRow>
                      ))
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        )
      }


    </Box>

  )
}

export { PaymentDetails };

